import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/(authorization)/sign-in/page.tsx");
